/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentFieldKey, TextInputData, TextInputModel } from '@typescript-kit/view';
import { SharedComponentKey } from '../key/shared-component.key';

export interface AutoCompleteInputData extends TextInputData {
  options?: string[];
  autoselectAfterOptionSelect?: boolean;
}

export class AutoCompleteInputFieldKey {
  static readonly OPTIONS = 'options';
  static readonly AUTOSELECT_AFTER_OPTION_SELECT = 'autoselectAfterOptionSelect';
}

export class AutoCompleteInputModel extends TextInputModel implements AutoCompleteInputData {
  static readonly KEYS = TextInputModel.KEYS.concat(
    Object.keys(AutoCompleteInputFieldKey).map((key) => AutoCompleteInputFieldKey[key])
  );

  constructor(data?: AutoCompleteInputData, keys?: string[]) {
    super(data, keys || AutoCompleteInputModel.KEYS);
  }

  get options(): string[] {
    return this.get(AutoCompleteInputFieldKey.OPTIONS);
  }

  set options(value: string[]) {
    this.set(AutoCompleteInputFieldKey.OPTIONS, value);
  }

  get autoselectAfterOptionSelect(): boolean {
    return this.get(AutoCompleteInputFieldKey.AUTOSELECT_AFTER_OPTION_SELECT, true);
  }

  set autoselectAfterOptionSelect(value: boolean) {
    this.set(AutoCompleteInputFieldKey.AUTOSELECT_AFTER_OPTION_SELECT, value);
  }

  protected setupValues(values: AutoCompleteInputData, exclusive: boolean): AutoCompleteInputData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = SharedComponentKey.AUTO_COMPLETE_INPUT;
    }
    return super.setupValues(values, exclusive) as AutoCompleteInputData;
  }
}
